export const globalTranslateSinister = (traduzir: string, personalKey?: string): string => {
	if (traduzir === "sketch") {
		return "Rascunho";
	}

	if (traduzir === "open") {
		return "Aberto";
	}

	if (traduzir === "in_progress") {
		return "Em andamento";
	}

	if (traduzir === "in_analysis") {
		return "Em análise";
	}

	if (traduzir === "debts_confession") {
		return "Confissão de dívidas";
	}

	if (traduzir === "finalized") {
		return "Finalizado";
	}

	if (traduzir === "monthly_compensation") {
		return "Indenizado Mensalmente";
	}

	if (traduzir === "lmi_exhaustion") {
		return "Esgotamento de LMI";
	}

	if (traduzir === "pending") {
		return "Pendente";
	}

	if (traduzir === "canceled") {
		return "Cancelado";
	}

	if (traduzir === "according") {
		return "Em Acordo";
	}

	if (traduzir === "preventive") {
		return "Acordo - Preventivo";
	}

	if (traduzir === "judicial") {
		return "Acordo - Judicial";
	}

	if (traduzir === "extrajudicial") {
		return "Acordo - Extrajudicial";
	}

	if (traduzir === "suspended") {
		return "Suspenso";
	}

	if (traduzir === "reversal") {
		return "Estorno";
	}

	if (traduzir === "transferred") {
		return "Repasse";
	}

	return traduzir;
};
